// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectAssetMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { FieldsFactory } from "../Factory/FieldsFactory.js";
import { MessageProcessorBase } from "./MessageProcessorBase.ts";

export let AssetTypeMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

AssetTypeMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

AssetTypeMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectAssetMessage()
    let ff = FieldsFactory

    msg.Id = fs.GetValue(ff.FIELD_ID)
    msg.Type = fs.GetValue(ff.FIELD_TYPE)
    // Assets feature
    // if (msg.Type === AssetType.SHARES)
    // {
    msg.RouteId = fs.GetValue(ff.FIELD_ROUTE_ID)
    msg.InstrumentTradableID = fs.GetValue(ff.FIELD_TRADABLE_INSTRUMENT_ID)
    msg.CreditForSell = fs.GetValue(ff.FIELD_CREDIT_FOR_SELL)
    msg.LiquidityRate = fs.GetValue(ff.FIELD_LIQUIDITY_RATE)
    // }

    msg.Name = fs.GetValue(ff.FIELD_NAME)
    msg.Description = fs.GetValue(ff.FIELD_DESCRIPTION)
    msg.MinChange = fs.GetValue(ff.FIELD_MIN_CHANGE)

    return [msg]
}
